import type { Routes } from '@angular/router';
import { permissionGuard } from '../../../auth/common/guards/permission.guard';
import { engineConfigResolver } from './common/resolvers/engine-config.resolver';

export const ENGINE_CONFIG_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./engine-config/engine-config.component').then(
        (m) => m.EngineConfigComponent,
      ),
    canActivate: [permissionGuard('engineConfig.get')],
    resolve: { engineConfig: engineConfigResolver },
  },
] as const;
